import React from 'react';
import { FaEdit } from "react-icons/fa";
import { browserHistory, Link } from "react-router";
// import { GET_FIRMS } from '../Graphql/Queries/FirmQuery';
import { GET_ALL_TEAMMEMBERS, GET_TEAMMEMBERS } from '../Graphql/Queries/TeamMemberQuery';
import svgEdit from '../../svgs/edit.svg';
import Icon from '../Icon/Icon';
import { GET_ALL_COMPANIES_FIRM_QUERY, GET_COMPANY_FIRM_QUERY } from '../Graphql/CompanyQueries/allCompanyQuery';
import { GET_CONTACT_TEAM_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import dollars from "../../dollar-format";
import { calculateYearsAndMonths, format_arcimedes_modified_Date, getCompletedYearsAndMonths, } from '../../utils';
import investorStatuses, { resolveInvestorStatus } from '../../investor-status';
import MergeIcon from "@mui/icons-material/Merge";

const statesData = [
  {
    "code": "AL",
    "label": "Alabama",
    "isTerritory": false
  },
  {
    "code": "AK",
    "label": "Alaska",
    "isTerritory": false
  },
  {
    "code": "AS",
    "label": "American Samoa",
    "isTerritory": true
  },
  {
    "code": "AZ",
    "label": "Arizona",
    "isTerritory": false
  },
  {
    "code": "AR",
    "label": "Arkansas",
    "isTerritory": false
  },
  {
    "code": "CA",
    "label": "California",
    "isTerritory": false
  },
  {
    "code": "CO",
    "label": "Colorado",
    "isTerritory": false
  },
  {
    "code": "CT",
    "label": "Connecticut",
    "isTerritory": false
  },
  {
    "code": "DE",
    "label": "Delaware",
    "isTerritory": false
  },
  {
    "code": "DC",
    "label": "District Of Columbia",
    "isTerritory": false
  },
  {
    "code": "FL",
    "label": "Florida",
    "isTerritory": false
  },
  {
    "code": "GA",
    "label": "Georgia",
    "isTerritory": false
  },
  {
    "code": "GU",
    "label": "Guam",
    "isTerritory": true
  },
  {
    "code": "HI",
    "label": "Hawaii",
    "isTerritory": false
  },
  {
    "code": "ID",
    "label": "Idaho",
    "isTerritory": false
  },
  {
    "code": "IL",
    "label": "Illinois",
    "isTerritory": false
  },
  {
    "code": "IN",
    "label": "Indiana",
    "isTerritory": false
  },
  {
    "code": "IA",
    "label": "Iowa",
    "isTerritory": false
  },
  {
    "code": "KS",
    "label": "Kansas",
    "isTerritory": false
  },
  {
    "code": "KY",
    "label": "Kentucky",
    "isTerritory": false
  },
  {
    "code": "LA",
    "label": "Louisiana",
    "isTerritory": false
  },
  {
    "code": "ME",
    "label": "Maine",
    "isTerritory": false
  },
  {
    "code": "MD",
    "label": "Maryland",
    "isTerritory": false
  },
  {
    "code": "MA",
    "label": "Massachusetts",
    "isTerritory": false
  },
  {
    "code": "MI",
    "label": "Michigan",
    "isTerritory": false
  },
  {
    "code": "MN",
    "label": "Minnesota",
    "isTerritory": false
  },
  {
    "code": "MS",
    "label": "Mississippi",
    "isTerritory": false
  },
  {
    "code": "MO",
    "label": "Missouri",
    "isTerritory": false
  },
  {
    "code": "MT",
    "label": "Montana",
    "isTerritory": false
  },
  {
    "code": "NE",
    "label": "Nebraska",
    "isTerritory": false
  },
  {
    "code": "NV",
    "label": "Nevada",
    "isTerritory": false
  },
  {
    "code": "NH",
    "label": "New Hampshire",
    "isTerritory": false
  },
  {
    "code": "NJ",
    "label": "New Jersey",
    "isTerritory": false
  },
  {
    "code": "NM",
    "label": "New Mexico",
    "isTerritory": false
  },
  {
    "code": "NY",
    "label": "New York",
    "isTerritory": false
  },
  {
    "code": "NC",
    "label": "North Carolina",
    "isTerritory": false
  },
  {
    "code": "ND",
    "label": "North Dakota",
    "isTerritory": false
  },
  {
    "code": "MP",
    "label": "Northern Mariana Islands",
    "isTerritory": true
  },
  {
    "code": "OH",
    "label": "Ohio",
    "isTerritory": false
  },
  {
    "code": "OK",
    "label": "Oklahoma",
    "isTerritory": false
  },
  {
    "code": "OR",
    "label": "Oregon",
    "isTerritory": false
  },
  {
    "code": "PA",
    "label": "Pennsylvania",
    "isTerritory": false
  },
  {
    "code": "PR",
    "label": "Puerto Rico",
    "isTerritory": true
  },
  {
    "code": "RI",
    "label": "Rhode Island",
    "isTerritory": false
  },
  {
    "code": "SC",
    "label": "South Carolina",
    "isTerritory": false
  },
  {
    "code": "SD",
    "label": "South Dakota",
    "isTerritory": false
  },
  {
    "code": "TN",
    "label": "Tennessee",
    "isTerritory": false
  },
  {
    "code": "TX",
    "label": "Texas",
    "isTerritory": false
  },
  {
    "code": "UT",
    "label": "Utah",
    "isTerritory": false
  },
  {
    "code": "VT",
    "label": "Vermont",
    "isTerritory": false
  },
  {
    "code": "VI",
    "label": "Virgin Islands",
    "isTerritory": true
  },
  {
    "code": "VA",
    "label": "Virginia",
    "isTerritory": false
  },
  {
    "code": "WA",
    "label": "Washington",
    "isTerritory": false
  },
  {
    "code": "WV",
    "label": "West Virginia",
    "isTerritory": false
  },
  {
    "code": "WI",
    "label": "Wisconsin",
    "isTerritory": false
  },
  {
    "code": "WY",
    "label": "Wyoming",
    "isTerritory": false
  }
];

const profileData = [
  { "code": 'Developer', "label": 'Developer' },
  { "code": 'Institutional Investor', "label": 'Institutional Investor' },
  { "code": 'Private Capital Investor', "label": 'Private Capital Investor' }
];
const vendorTypeData = [
  { code: '1031 Accommodator', label: '1031 Accommodator' },
  { code: 'Appraiser', label: 'Appraiser' },
  { code: 'Attorney', label: 'Attorney' },
  { code: 'Environmental Consultant', label: 'Environmental Consultant' },
  { code: 'Inspector', label: 'Inspector' },
  { code: 'Insurance Broker', label: 'Insurance Broker' },
  { code: 'Lender', label: 'Lender' },
  { code: 'Mortgage Broker', label: 'Mortgage Broker' },
  { code: 'Other', label: 'Other' },
  { code: 'Property Manager', label: 'Property Manager' },
  {code:'Roofer',label:'Roofer'},
  { code: 'Surveyor', label: 'Surveyor' },
  { code: 'Tax Consultant', label: 'Tax Consultant' },
  { code: 'Title Company', label: 'Title Company' },
];

export const AGENTS_COLUMNS = [
  {
    Header: "VIEW/EDIT",
    accessor: "view",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >
        <Link
          // to={`${arc.path.base}agent/${row.original.contact_id}`}
          to={{
            pathname: `${arc.path.base}agent/${row.original.contact_id}`,
            state: { fromListUrl: window.location.pathname + window.location.search },
          }}
          style={{
            cursor: "pointer",
            fontSize: "24px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#90c54b");
          }}
          onMouseLeave={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#939393");
          }}
        >
          <Icon svg={svgEdit} />
        </Link>

      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
  {
    Header: "MERGE",
    accessor: "merge",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >

        <Link
          to={{
            pathname: `${arc.path.base}${"merging"}/${"contacts"}/${row.original.first_name + " " + row.original.last_name
              }`,
          }}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#90c54b");
              });
          }}
          onMouseLeave={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#939393");
              });
          }}
        >
          <MergeIcon />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
  {
    Header: 'FIRST NAME',
    accessor: 'first_name',
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "first_name",
    sortParam: "first_name"
  },
  {
    Header: 'LAST NAME',
    accessor: 'last_name',
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "last_name",
    sortParam: "last_name"
  },
  {
    Header: 'EMAIL',
    accessor: (row) => (row.email ? <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "email",
    sortParam: "email"
  },
  {
    Header: 'WORK PHONE',
    accessor: (row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('/[()]/g', '')}`}>{row.phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "phone",
    sortParam: "phone"
  },
  {
    Header: 'CELL PHONE',
    accessor: (row) => (row.cell_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.cell_phone.replace(' ', '-').replace('/[()]/g', '')}`}>{row.cell_phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "cell_phone",
    sortParam: "cell_phone"
  },
  {
    Header: "ADDRESS",
    accessor: (row) => `${row.address ? row.address : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "address",
    sortParam: "address"
  },
    {
    Header: 'COMPANY ADDRESS',
     accessor: (row) => `${row.company_address ? row.company_address : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_address",
    sortParam: "company_address"
  },
  {
    Header: 'COMPANY',
    accessor: 'firm',
    isInputFilter: true,
    filterType: "Dropdown",
    query: GET_COMPANY_FIRM_QUERY,
    dropDownOptions: [],
    queryParam: "firm",
    sortParam: "firm",
    queryType: "Firm"
  },
 
  {
    Header: "CITY",
    accessor: (row) => `${row.city ? row.city : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "city",
    sortParam: "city"
  }, {
    Header: "STATE",
    accessor: (row) => `${row.state ? row.state : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: statesData,
    queryParam: "state",
    sortParam: "state"
  }, {
    Header: "ZIP",
    accessor: (row) => `${row.zip ? row.zip : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "zip",
    sortParam: "zip"
  }
]

export const BUYERS_COLMNS = [
  {
    Header: "VIEW/EDIT",
    accessor: "view",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >
        <Link
          //   to={`${arc.path.base}investor/${row.original.contact_id}`
          // }
          to={{
            pathname: `${arc.path.base}investor/${row.original.contact_id}`,
            state: { fromListUrl: window.location.pathname + window.location.search },
          }}
          style={{
            cursor: "pointer",
            fontSize: "24px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#90c54b");
          }}
          onMouseLeave={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#939393");
          }}
        >
          <Icon svg={svgEdit} />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: true
  },
  {
    Header: 'STATUS',
    accessor: (row) => (row.status ? row.status : "-"),
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [{ "code": "1031-Buyer", "label": "1031-Buyer" },
    { "code": "Prior 1031", "label": "Prior 1031" },
    { "code": "Active", "label": "Active" },
    { "code": "Off-Market", "label": "Off-Market" },
    ],
    queryParam: "status",
    sortParam: "status"
  }, {
    Header: 'CATEGORY',
    accessor: (row) => (row.category ? row.category : "-"),
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [
      {
        code: 'industrial',
        label: 'Industrial',
      },
      {
        code: 'apartments',
        label: 'Multi-Family',
      },
      {
        code: 'office',
        label: 'Office',
      },
      {
        code: 'retail',
        label: 'Retail',
      },
      {
        code: 'other',
        label: 'Other',
      },
    ],
    queryParam: "category",
    sortParam: "category"
  }, {
    Header: 'TYPE',
    accessor: (row) => (row.type ? row.type : "-"),
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [
      {
        code: 'STNL',
        label: 'Single-Tenant',
      },
      {
        code: 'MT',
        label: 'Multi-Tenant',
      },
      {
        code: 'Other',
        label: 'Other',
      },
    ],
    queryParam: "type",
    sortParam: "type"
  }, {
    Header: 'SUBCATEGORY',
    accessor: row => row.type === 'MT' ? row.multi_tenant_subcategory : row.single_tenant_subcategory,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [
      { "code": "Cold Storage", "label": "Cold Storage" },
      { "code": "Data Center", "label": "Data Center" },
      { "code": "Distribution", "label": "Distribution" },
      { "code": "Flex", "label": "Flex" },
      { "code": "Logistics", "label": "Logistics" },
      { "code": "Manufacturing", "label": "Manufacturing" },
      { "code": "Owner-User", "label": "Owner-User" },
      { "code": "Other", "label": "Other" },
      { "code": "Research & Development", "label": "Research & Development" },
      { "code": "Showroom", "label": "Showroom" },
      { "code": "Vacant", "label": "Vacant" },
      { "code": "Warehouse", "label": "Warehouse" },
    ],
    queryParam: row => row.type === 'MT' ? "multi_tenant_subcategory" : "single_tenant_subcategory",
    sortParam: row => row.type === 'MT' ? "multi_tenant_subcategory" : "single_tenant_subcategory",
    rowType: row => row.type
  }, {
    Header: 'MARKET',
    accessor: (row) => (row.market ? row.market : "-"),
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [
      { "code": "DFW", "label": "DFW" },
      { "code": "Houston", "label": "Houston" },
      { "code": "Central", "label": "Central" },
      { "code": "East", "label": "East" },
      { "code": "Valley", "label": "Valley" },
      { "code": "Austin", "label": "Austin" },
      { "code": "San Antonio", "label": "San Antonio" },
      { "code": "West", "label": "West" },
      { "code": "Other", "label": "Other" },
    ],
    queryParam: "market",
    sortParam: "market"
  },

  {
    Header: 'PRICE MIN',
    accessor: (row) => (row.price_min ? dollars(row.price_min) : "-"),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "price_min",
    sortParam: "price_min"
  },
  {
    Header: 'PRICE MAX',
    accessor: (row) => (row.price_max ? dollars(row.price_max) : "-"),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "price_max",
    sortParam: "price_max"
  },
  {
    Header: 'CAP RATE MIN',
    accessor: (row) => (row.cap_rate_min ? `${row.cap_rate_min}%` : ""),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "cap_rate_min",
    sortParam: "cap_rate_min"
  },
  {
    Header: 'CAP RATE MAX',
    accessor: (row) => (row.cap_rate_max ? `${row.cap_rate_max}%` : "-"),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "cap_rate_max",
    sortParam: "cap_rate_max"
  },


  {
    Header: 'FIRST NAME',
    accessor: (row) => (row.first_name ? row.first_name : "-"),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "first_name",
    sortParam: "first_name"
  },
  {
    Header: 'LAST NAME',
    accessor: (row) => (row.last_name ? row.last_name : "-"),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "last_name",
    sortParam: "last_name"
  },

  {
    Header: 'EMAIL',
    accessor: (row) => (row.email ? <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "email",
    sortParam: "email"
  },
  {
    Header: 'PHONE',
    accessor: (row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "phone",
    dropDownOptions: [],
    queryParam: "phone",
    sortParam: "phone"
  }, {
    Header: 'COMPANY NAME',
    accessor: (row) => (row.company_name ? row.company_name : "-"),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_name",
    sortParam: "company_name"
  }, {
    Header: 'AGENT',
    accessor: (row) => (row.strive_agent_last_name ? row.strive_agent_last_name : "-"),
    isInputFilter: true,
    filterType: "Dropdown",
    query: GET_CONTACT_TEAM_LIST_QUERY,
    dropDownOptions: [],
    queryParam: "strive_agent",
    sortParam: "strive_agent_last_name",
    queryType: "Team"
  },
  {
    Header: "COMPANY ADDRESS",
    accessor: (row) => `${row.company_address ? row.company_address : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_address",
    sortParam: "company_address"
  },
  {
    Header: "CITY",
    accessor: (row) => `${row.company_city ? row.company_city : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_city",
    sortParam: "company_city"
  }, {
    Header: "STATE",
    accessor: (row) => `${row.company_state ? row.company_state : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: statesData,
    queryParam: "company_state",
    sortParam: "company_state"
  }, {
    Header: "ZIP",
    accessor: (row) => `${row.company_zip ? row.company_zip : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_zip",
    sortParam: "company_zip"
  },
  {
    Header: "PROFILE",
    accessor: (row) => `${row.profile ? row.profile : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: profileData,
    queryParam: "profile",
    sortParam: "profile"
  },
  // {
  //   Header: "NOTES",
  //   accessor: (row) => `${row.notes ? row.notes : "-"}`,
  //   isInputFilter: true,
  //   filterType:"text",
  //   query : "",
  //   dropDownOptions: [],
  //   queryParam : "notes",
  //   sortParam: "notes"
  // },
];

export const Investors_COLMNS = [
  {
    Header: "VIEW/EDIT",
    accessor: "view",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >
        <Link
          // to={`${arc.path.base}investor/${row.original.contact_id}`}
          to={{
            pathname: `${arc.path.base}investor/${row.original.contact_id}`,
            state: { fromListUrl: window.location.pathname + window.location.search },
          }}
          style={{
            cursor: "pointer",
            fontSize: "24px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#90c54b");
          }}
          onMouseLeave={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#939393");
          }}
        >
          <Icon svg={svgEdit} />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: true
  },
  {
    Header: "MERGE",
    accessor: "merge",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >

        <Link
          to={{
            pathname: `${arc.path.base}${"merging"}/${"contacts"}/${row.original.first_name + " " + row.original.last_name
              }`,
          }}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#90c54b");
              });
          }}
          onMouseLeave={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#939393");
              });
          }}
        >
          <MergeIcon />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
    
  {
    Header: 'FIRST NAME',
    accessor: (row) => (row.first_name ? row.first_name : "-"),
    isInputFilter : true,
    filterType:"text",
    query : "",
    dropDownOptions: [],
    queryParam : "first_name",
    sortParam: "first_name"
  },
  {
    Header: 'LAST NAME',
    accessor: (row) => (row.last_name ? row.last_name : "-"),
    isInputFilter : true,
    filterType:"text",
    query : "",
    dropDownOptions: [],
    queryParam : "last_name",
    sortParam: "last_name"
  },
  {
  Header: 'EMAIL',
  accessor: (row) => (row.email ? <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> : null), 
  isInputFilter : true,
  filterType:"text",
  query : "",
  dropDownOptions: [],
  queryParam : "email",
  sortParam: "email"
}, 
{
  Header: 'WORK PHONE',
  accessor:(row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.phone}</a> : null), 
  isInputFilter : true,
  filterType:"text",
  query : "phone",
  dropDownOptions: [],
  queryParam : "phone",
  sortParam: "phone"
},{
    Header: 'CELL PHONE',
    accessor: (row) => (row.cell_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.cell_phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.cell_phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    sortParam: "cell_phone",
    queryParam: "cell_phone"
  },
  {
    Header: 'COMPANY',
    accessor: (row) => (row.company_name ? row.company_name : "-"), 
    isInputFilter : true,
    filterType:"text",
    query : "",
    dropDownOptions: [],
    queryParam : "company_name",
    sortParam: "company_name"
}, 
{
  Header: "ADDRESS",
  accessor: (row) => `${row.company_address ? row.company_address : "-"}`,
  isInputFilter: true,
  filterType:"text",
  query : "",
  dropDownOptions: [],
  queryParam : "company_address",
  sortParam: "company_address"
},
{
  Header: "CITY",
  accessor: (row) => `${row.company_city ? row.company_city : "-"}`,
  isInputFilter: true,
  filterType:"text",
  query : "",
  dropDownOptions: [],
  queryParam : "company_city",
  sortParam: "company_city"
}, {
  Header: "STATE",
  accessor: (row) => `${row.company_state ? row.company_state : "-"}`,
  isInputFilter: true,
  filterType:"Static Dropdown",
  query : "",
  dropDownOptions: statesData,
  queryParam : "company_state",
  sortParam: "company_state"
}, {
  Header: "ZIP",
  accessor: (row) => `${row.company_zip ? row.company_zip : "-"}`,
  isInputFilter: true,
  filterType:"text",
  query : "",
  dropDownOptions: [],
  queryParam : "company_zip",
  sortParam : "company_zip"
},

  {
    Header: 'STATUS',
    accessor: (row) => (row.status ? resolveInvestorStatus(row.status, row.date_of_down_leg) : "-"),
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: investorStatuses.map((status) => ({ code: status, label: status })),
    queryParam: "status",
    sortParam: "status"
  }, {
    Header: 'CATEGORY',
    accessor: (row) => (row.category ? row.category : "-"),
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [
      {
        code: 'industrial',
        label: 'Industrial',
      },
      {
        code: 'apartments',
        label: 'Multi-Family',
      },
      {
        code: 'office',
        label: 'Office',
      },
      {
        code: 'retail',
        label: 'Retail',
      },
      {
        code: 'other',
        label: 'Other',
      },
    ],
    queryParam: "category",
    sortParam: "category"
  }, {
    Header: 'TYPE',
    accessor: (row) => (row.type ? row.type : "-"),
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [
      {
        code: 'STNL',
        label: 'Single-Tenant',
      },
      {
        code: 'MT',
        label: 'Multi-Tenant',
      },
      {
        code: 'Other',
        label: 'Other',
      },
    ],
    queryParam: "type",
    sortParam: "type"
  }, {
    Header: 'SUBCATEGORY',
    accessor: row => row.type === 'MT' ? row.multi_tenant_subcategory : row.single_tenant_subcategory,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [
      { "code": "Cold Storage", "label": "Cold Storage" },
      { "code": "Data Center", "label": "Data Center" },
      { "code": "Distribution", "label": "Distribution" },
      { "code": "Flex", "label": "Flex" },
      { "code": "Logistics", "label": "Logistics" },
      { "code": "Manufacturing", "label": "Manufacturing" },
      { "code": "Owner-User", "label": "Owner-User" },
      { "code": "Other", "label": "Other" },
      { "code": "Research & Development", "label": "Research & Development" },
      { "code": "Showroom", "label": "Showroom" },
      { "code": "Vacant", "label": "Vacant" },
      { "code": "Warehouse", "label": "Warehouse" },
    ],
    queryParam: row => row.type === 'MT' ? "multi_tenant_subcategory" : "single_tenant_subcategory",
    sortParam: row => row.type === 'MT' ? "multi_tenant_subcategory" : "single_tenant_subcategory",
    rowType: row => row.type
  }, {
    Header: 'MARKET',
    accessor: (row) => (row.market ? row.market : "-"),
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [
      { "code": "DFW", "label": "DFW" },
      { "code": "Houston", "label": "Houston" },
      { "code": "Central", "label": "Central" },
      { "code": "East", "label": "East" },
      { "code": "Valley", "label": "Valley" },
      { "code": "Austin", "label": "Austin" },
      { "code": "San Antonio", "label": "San Antonio" },
      { "code": "West", "label": "West" },
      { "code": "Other", "label": "Other" },
    ],
    queryParam: "market",
    sortParam: "market"
  },

      {
        Header: 'PRICE MIN',
        accessor: (row) => (row.price_min ? dollars(row.price_min) : "-"), 
        isInputFilter : true,
        filterType:"text",
        query : "",
        dropDownOptions: [],
        queryParam : "price_min",
        sortParam: "price_min"
      },
      {
        Header: 'PRICE MAX',
        accessor: (row) => (row.price_max ? dollars(row.price_max) : "-"),
        isInputFilter : true,
        filterType:"text",
        query : "",
        dropDownOptions: [],
        queryParam : "price_max",
        sortParam: "price_max"
      },
      {
        Header: 'CAP RATE MIN',
        accessor: (row) => (row.cap_rate_min ? `${row.cap_rate_min}%` : ""),
        isInputFilter : true,
        filterType:"text",
        query : "",
        dropDownOptions: [],
        queryParam : "cap_rate_min",
        sortParam: "cap_rate_min"
      },
      {
        Header: 'CAP RATE MAX',
        accessor: (row) => (row.cap_rate_max ? `${row.cap_rate_max}%` : "-"),
        isInputFilter : true,
        filterType:"text",
        query : "",
        dropDownOptions: [],
        queryParam : "cap_rate_max",
        sortParam: "cap_rate_max" 
      },
      {
        Header: "PROFILE",
        accessor: (row) => `${row.profile ? row.profile : "-"}`,
        isInputFilter: true,
        filterType:"Static Dropdown",
        query : "",
        dropDownOptions: profileData,
        queryParam : "profile",
        sortParam: "profile"
      },
   {
    Header: 'AGENT',
    accessor: (row) => (row.strive_agent_last_name ? row.strive_agent_last_name : "-"),
    isInputFilter: true,
    filterType: "Dropdown",
    query: GET_CONTACT_TEAM_LIST_QUERY,
    dropDownOptions: [],
    queryParam: "strive_agent",
    sortParam: "strive_agent_last_name",
    queryType: "Team"
  },
  // {
  //   Header: "NOTES",
  //   accessor: (row) => `${row.notes ? row.notes : "-"}`,
  //   isInputFilter: true,
  //   filterType:"text",
  //   query : "",
  //   dropDownOptions: [],
  //   queryParam : "notes",
  //   sortParam: "notes"
  // },
];

export const FIRMS_COLUMNS = [
  {
    Header: "VIEW/EDIT",
    accessor: "view",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >
        <Link
          // to={`${arc.path.base}firm/${row.original.company_id}`}
          to={{
            pathname: `${arc.path.base}firm/${row.original.company_id}`,
            state: { fromListUrl: window.location.pathname + window.location.search },
          }}
          style={{
            cursor: "pointer",
            fontSize: "24px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#90c54b");
          }}
          onMouseLeave={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#939393");
          }}
        >
          <Icon svg={svgEdit} />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
  {
    Header: "MERGE",
    accessor: "merge",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >

        <Link
          to={{
            pathname: `${arc.path.base}${"merging"}/${"company"}/${row.original.name}`,
          }}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#90c54b");
              });
          }}
          onMouseLeave={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#939393");
              });
          }}
        >
          <MergeIcon />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
  {
    Header: 'COMPANY',
    accessor: 'name',
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "name",
    sortParam: "name"
  }, {
    Header: 'ADDRESS',
    accessor: 'address',
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "address",
    sortParam: "address"
  }, {
    Header: 'CITY',
    accessor: 'city',
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "city",
    sortParam: "city"
  }, {
    Header: 'STATE',
    accessor: 'state',
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: statesData,
    queryParam: "state",
    sortParam: "state"
  },
  {
    Header: 'ZIP',
    accessor: (row) => `${row.zip ? row.zip : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "zip",
    sortParam: "zip"
  }, {
    Header: 'PHONE',
    accessor: (row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('/[()]/g', '')}`}>{row.phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "phone",
    sortParam: "phone"
  }, {
    Header: 'WEBSITE',
    accessor: 'website',
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "website",
    sortParam: "website"
  },
  //  {
  //   Header: "Email",
  //   accessor: "email",
  //   isInputFilter: true,
  //   filterType: "text",
  //   query: "",
  //   dropDownOptions: [],
  //   queryParam: "email",
  //   sortParam: "email"
  // }, 
  {
    Header: "PARENT COMPANY",
    accessor: "firm",
    isInputFilter: true,
    filterType: "Dropdown",
    query: GET_COMPANY_FIRM_QUERY,
    dropDownOptions: [],
    queryParam: "parent_firm",
    sortParam: "parent_firm",
    queryType: "Firm"
  },
];

export const TENANTS_COLUMNS = [
  {
    Header: "VIEW/EDIT",
    accessor: "view",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          paddingLeft: "12px",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "50%"// Adjust based on parent container
        }}
      >
        <Link
          // to={`${arc.path.base}tenant/${row.original.contact_id}`}
          to={{
            pathname: `${arc.path.base}tenant/${row.original.contact_id}`,
            state: { fromListUrl: window.location.pathname + window.location.search },
          }}
          style={{
            cursor: "pointer",
            fontSize: "24px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#90c54b");
          }}
          onMouseLeave={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#939393");
          }}
        >
          <Icon svg={svgEdit} />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
  {
    Header: "MERGE",
    accessor: "merge",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >

        <Link
          to={{
            pathname: `${arc.path.base}${"merging"}/${"contacts"}/${row.original.first_name + " " + row.original.last_name
              }`,
          }}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#90c54b");
              });
          }}
          onMouseLeave={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#939393");
              });
          }}
        >
          <MergeIcon />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
  // {
  //       Header: 'TENANT',
  //       accessor:'name',
  //       isInputFilter : true,
  //       filterType:"text",
  //       query : "",
  //       dropDownOptions: [],
  //       queryParam : "name",
  //       sortParam: "name"
  //   },
  {
    Header: 'FIRST NAME',
    accessor: 'first_name',
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "first_name",
    sortParam: "first_name"
  },
  {
    Header: 'LAST NAME',
    accessor: 'last_name',
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "last_name",
    sortParam: "last_name"
  },
  {
    Header: "ADDRESS",
    accessor: (row) => `${row.address ? row.address : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "address",
    sortParam: "address"
  },
  {
    Header: "CITY",
    accessor: (row) => `${row.city ? row.city : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "city",
    sortParam: "city"
  }, {
    Header: "STATE",
    accessor: (row) => `${row.state ? row.state : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: statesData,
    queryParam: "state",
    sortParam: "state"
  }, {
    Header: "ZIP",
    accessor: (row) => `${row.zip ? row.zip : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "zip",
    sortParam: "zip"
  }

];

export const LENDERS_COLUMNS = [
  {
    Header: "VIEW/EDIT",
    accessor: "view",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >
        <Link
          // to={`${arc.path.base}lender/${row.original.contact_id}`}
          to={{
            pathname: `${arc.path.base}lender/${row.original.contact_id}`,
            state: { fromListUrl: window.location.pathname + window.location.search },
          }}
          style={{
            cursor: "pointer",
            fontSize: "24px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#90c54b");
          }}
          onMouseLeave={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#939393");
          }}
        >
          <Icon svg={svgEdit} />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
  {
    Header: "MERGE",
    accessor: "merge",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >

        <Link
          to={{
            pathname: `${arc.path.base}${"merging"}/${"contacts"}/${row.original.first_name + " " + row.original.last_name
              }`,
          }}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#90c54b");
              });
          }}
          onMouseLeave={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#939393");
              });
          }}
        >
          <MergeIcon />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
  {
    Header: 'FIRST NAME',
    accessor: 'first_name',
    isInputFilter: true,
    filterType: "first_name",
    query: "",
    dropDownOptions: [],
    queryParam: "first_name",
    sortParam: "first_name"
  }, {
    Header: 'LAST NAME',
    accessor: 'last_name',
    isInputFilter: true,
    filterType: "last_name",
    query: "",
    dropDownOptions: [],
    queryParam: "last_name",
    sortParam: "last_name"
  },
  {
    Header: 'EMAIL',
    accessor: (row) => (row.email ? <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "email",
    sortParam: "email"
  }, {
    Header: 'WORK PHONE',
    accessor: (row) => (row.contact_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.contact_phone.replace(' ', '-').replace('/[()]/g', '')}`}>{row.contact_phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "contact_phone",
    sortParam: "contact_phone"
  },
  {
    Header: 'CELL PHONE',
    accessor: (row) => (row.cell_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.cell_phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.cell_phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    sortParam: "cell_phone",
    queryParam: "cell_phone"
  },
  {
    Header: 'COMPANY',
    accessor: 'name',
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "name",
    sortParam: "name"
  },
  {
    Header: "ADDRESS",
    accessor: (row) => `${row.address ? row.address : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "address",
    sortParam: "address"
  },
  {
    Header: 'CITY',
    accessor: 'city',
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "city",
    sortParam: "city"
  }, {
    Header: 'STATE',
    accessor: 'state',
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: statesData,
    queryParam: "state",
    sortParam: "state"
  },
  {
    Header: "ZIP",
    accessor: (row) => `${row.zip ? row.zip : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "zip",
    sortParam: "zip"
  }
  // {
  //     Header: 'EMAIL',
  //     accessor:(row) => (row.contact_email ? <a style={{ color: "#90C54B" }} href={`mailto:${row.contact_email}`}>{row.contact_email}</a> : null),
  //     isInputFilter : true,
  //     filterType:"text",
  //     query : "",
  //     dropDownOptions: [],
  //     queryParam : "contact_email",
  //     sortParam: "contact_email"
  // },
  
   

];

export const TEAM_MEMBERS_COLUMNS = [
  {
    Header: "VIEW/EDIT",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >
        <Link
          onClick={() => {
            sessionStorage.setItem(
              "lastClickedTeamMember",
              row.original.contact_id
            );
          }}
          // to={{ pathname: `${arc.path.base}teamMember/${row.original.contact_id}`}}
          to={{
            pathname: `${arc.path.base}teamMember/${row.original.contact_id}/${row.original.email}`,
            state: { fromListUrl: window.location.pathname + window.location.search },
          }}
          style={{
            cursor: "pointer",
            fontSize: "24px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#90c54b");
          }}
          onMouseLeave={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#939393");
          }}
        >
          <Icon svg={svgEdit} />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
  // {
  //   Header: "MERGE",
  //   accessor: "merge",
  //   Cell: ({ row }) => (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         height: "100%", // Adjust based on parent container
  //         width: "100%",  // Adjust based on parent container
  //       }}
  //     >

  //       <Link
  //         to={{
  //           pathname: `${arc.path.base}${"merging"}/${"contacts"}/${row.original.first_name + " " + row.original.last_name
  //             }`,
  //         }}
  //         style={{
  //           cursor: "pointer",
  //           fontSize: "20px",
  //           color: "rgb(100, 100, 100)",
  //           backgroundColor: "transparent",
  //           border: "none",
  //           display: "flex",
  //           alignItems: "center",
  //           gap: "4px",
  //           textDecoration: "none",
  //         }}
  //         onMouseEnter={(e) => {
  //           e.currentTarget
  //             .querySelectorAll("svg path")
  //             .forEach((path) => {
  //               path.setAttribute("fill", "#90c54b");
  //             });
  //         }}
  //         onMouseLeave={(e) => {
  //           e.currentTarget
  //             .querySelectorAll("svg path")
  //             .forEach((path) => {
  //               path.setAttribute("fill", "#939393");
  //             });
  //         }}
  //       >
  //         <MergeIcon />
  //       </Link>
  //     </div>
  //   ),
  //   isAction: true,
  //   filterType: "text",
  //   query: "",
  //   dropDownOptions: [],
  //   queryParam: "",
  //   sortParam: "",
  //   cascadeColumns: false,
  // },
  {
    Header: 'ROLE',
    accessor: (row) => `${row.is_agent === "y" ? "Agent" : row.is_agent === "h" ? "AthCap - Agent" : row.is_agent === "e" ? "AthCap - Employee" : row.is_agent === "i" ? "Intern" : row.is_agent === "n" ? "Employee" :  ""}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [{
      code: 'n',
      label: 'Employee',
    },
    {
      code: 'y',
      label: 'Agent',
    },
    {
      code: 'h',
      label: 'AthCap - Agent',
    },
    {
      code: 'e',
      label: 'AthCap - Employee',
    },
    {
      code: 'i',
      label: 'Intern',
    }],
    queryParam: "is_agent",
    sortParam: "is_agent"
  },
  {
    Header: 'NAME',
    accessor: (row) => row.first_name && row.last_name ? `${row.first_name} ${row.last_name}` : '',
    isInputFilter: true,
    filterType: "Dropdown",
    query: GET_CONTACT_TEAM_LIST_QUERY,
    dropDownOptions: [],
    queryParam: "arcimedes_row_id",
    sortParam: "first_name",
    queryType: "Team"
  }, {
    Header: 'WORK PHONE',
    accessor: (row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "phone",
    sortParam: "phone"
  }, {
    Header: 'CELL PHONE',
    accessor: (row) => (row.cell_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.cell_phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.cell_phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    sortParam: "cell_phone",
    queryParam: "cell_phone"

  }, {
    Header: 'START DATE',
    accessor: (row) => `${row.starting_date ? row.starting_date : " "}`,
    isInputFilter: true,
    filterType: "datepicker",
    query: "",
    dropDownOptions: [],
    sortParam: "starting_date",
    queryParam: "starting_date_min",
    queryParam1: "starting_date_max"
  },
  {
    Header: 'YRS AT STRIVE',
    accessor: (row) => `${row.yrs_at_strive ? row.yrs_at_strive : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "yrs_at_strive",
    sortParam: "yrs_at_strive"
  },
  {
    Header: 'BIRTH DATE',
    accessor: (row) => `${row.birth_date ? row.birth_date : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "birth_date",
    sortParam: "birth_date"
  },
  {
    Header: 'ON PHONES',
    accessor: (row) => `${row.on_phones ? row.on_phones : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "on_phones",
    sortParam: "on_phones"
  },
  /*{
    Header: 'IN POOLS',
    accessor: (row) => `${row.in_pool ? row.in_pool : ''}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "in_pool",
    sortParam: "in_pool"
  },*/
  {
    Header: '1ST LISTING',
    accessor: (row) => `${row.first_listing ? row.first_listing : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "first_listing",
    sortParam: "first_listing"
  }, {
    Header: '1ST CLOSING',
    accessor: (row) => `${row.first_closing ? row.first_closing : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "first_closing",
    sortParam: "first_closing"
  }, {
    Header: 'ADDRESS',
    accessor: (row) => `${row.address ? row.address : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "address",
    sortParam: "address"
  }, {
    Header: 'CITY',
    accessor: (row) => `${row.city ? row.city : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "city",
    sortParam: "city"
  },
  {
    Header: "STATE",
    accessor: (row) => `${row.state ? row.state : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: statesData,
    queryParam: "state",
    sortParam: "state"
  }, {
    Header: 'ZIP',
    accessor: (row) => `${row.zip ? row.zip : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "zip",
    sortParam: "zip"
  },
];


export const SELLERS_COLUMNS = [
  {
    Header: "VIEW/EDIT",
    Cell: ({ row }) => (
      <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%", // Adjust based on parent container
        width: "100%",  // Adjust based on parent container
      }}
    >
      <Link
        // to={{
        //   pathname: `${arc.path.base}seller/${row.original.contact_id}`,
        // }}
        to={{
          pathname: `${arc.path.base}seller/${row.original.contact_id}`,
          state: { fromListUrl: window.location.pathname + window.location.search }
        }}
        style={{
          cursor: "pointer",
          fontSize: "24px",
          color: "rgb(100, 100, 100)",
          backgroundColor: "transparent",
          border: "none",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          textDecoration: "none",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#90c54b");
        }}
        onMouseLeave={(e) => {
          e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#939393");
        }}
      >
        <Icon svg={svgEdit} />
      </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: true,
  },
  {
    Header: 'STATUS',
    accessor: (row) => `${row.status ? row.status : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [{ code: "Off-Market", label: "Off-Market" }],
    queryParam: "status",
    sortParam: "status"

  },

  {
    Header: 'FIRST NAME',
    accessor: 'first_name',
    Cell: ({ value }) => value || "-",
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "first_name",
    sortParam: "first_name"
  },
  {
    Header: 'LAST NAME',
    accessor: 'last_name',
    Cell: ({ value }) => value || "-",
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "last_name",
    sortParam: "last_name"
  },

  {
    Header: 'EMAIL',
    accessor: (row) => (
      row.email ?
        <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> :
        null
    ),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "email",
    sortParam: "email"
  },
  {
    Header: 'PHONE',
    accessor: (row) => (
      row.phone ?
        <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>
          {row.phone}
        </a> :
        null
    ),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "phone",
    sortParam: "phone"
  },
  {
    Header: 'COMPANY NAME',
    accessor: (row) => `${row.company_name ? row.company_name : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_name",
    sortParam: "company_name"

  },
  {
    Header: "PROFILE",
    accessor: (row) => `${row.profile ? row.profile : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: profileData,
    queryParam: "profile",
    sortParam: "profile"
  }, {
    Header: "COMPANY ADDRESS",
    accessor: (row) => `${row.company_address ? row.company_address : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_address",
    sortParam: "company_address"
  },
  {
    Header: "CITY",
    accessor: (row) => `${row.company_city ? row.company_city : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_city",
    sortParam: "company_city"
  }, {
    Header: "STATE",
    accessor: (row) => `${row.company_state ? row.company_state : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: statesData,
    queryParam: "company_state",
    sortParam: "company_state"
  }, {
    Header: "ZIP",
    accessor: (row) => `${row.company_zip ? row.company_zip : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_zip",
    sortParam: "company_zip"
  },
  // {
  //   Header: "NOTES",
  //   accessor: (row) => `${row.notes ? row.notes : "-"}`,
  //   isInputFilter: true,
  //   filterType:"text",
  //   query : "",
  //   dropDownOptions: [],
  //   queryParam : "notes",
  //   sortParam: "notes"
  // },
];

export const VENDORS_COLUMNS = [
  {
    Header: "VIEW/EDIT",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >
        <Link
          to={{
            // pathname: `${arc.path.base}vendor/${row.original.contact_id}`,
            pathname: `${arc.path.base}vendor/${row.original.contact_id}`,
            state: { fromListUrl: window.location.pathname + window.location.search },
          }}
          style={{
            cursor: "pointer",
            fontSize: "24px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#90c54b");
          }}
          onMouseLeave={(e) => {
            e.currentTarget.querySelector("svg path:nth-child(2)").setAttribute("fill", "#939393");
          }}
        >
          <Icon svg={svgEdit} />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: true,
  },
  {
    Header: "MERGE",
    accessor: "merge",
    Cell: ({ row }) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%", // Adjust based on parent container
          width: "100%",  // Adjust based on parent container
        }}
      >

        <Link
          to={{
            pathname: `${arc.path.base}${"merging"}/${"contacts"}/${row.original.first_name + " " + row.original.last_name
              }`,
          }}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "rgb(100, 100, 100)",
            backgroundColor: "transparent",
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#90c54b");
              });
          }}
          onMouseLeave={(e) => {
            e.currentTarget
              .querySelectorAll("svg path")
              .forEach((path) => {
                path.setAttribute("fill", "#939393");
              });
          }}
        >
          <MergeIcon />
        </Link>
      </div>
    ),
    isAction: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "",
    sortParam: "",
    cascadeColumns: false,
  },
  {
    Header: 'VENDOR TYPE',
    accessor: (row) => `${row.vendor_type ? row.vendor_type : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: vendorTypeData,
    queryParam: "vendor_type",
    sortParam: "vendor_type"

  },
  {
    Header: 'FIRST NAME',
    accessor: 'first_name',
    Cell: ({ value }) => value || "-",
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "first_name",
    sortParam: "first_name"
  },
  {
    Header: 'LAST NAME',
    accessor: 'last_name',
    Cell: ({ value }) => value || "-",
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "last_name",
    sortParam: "last_name"
  },

  {
    Header: 'EMAIL',
    accessor: (row) => (
      row.email ?
        <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> :
        null
    ),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "email",
    sortParam: "email"
  },
  {
    Header: 'WORK PHONE',
    accessor: (row) => (
      row.phone ?
        <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>
          {row.phone}
        </a> :
        null
    ),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "phone",
    sortParam: "phone"
  },
  {
    Header: 'CELL PHONE',
    accessor: (row) => (row.cell_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.cell_phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.cell_phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    sortParam: "cell_phone",
    queryParam: "cell_phone"
  },
  {
    Header: 'COMPANY',
    accessor: (row) => `${row.company_name ? row.company_name : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_name",
    sortParam: "company_name"

  },
  {
    Header: "ADDRESS",
    accessor: (row) => `${row.company_address ? row.company_address : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_address",
    sortParam: "company_address"
  },
  {
    Header: "CITY",
    accessor: (row) => `${row.company_city ? row.company_city : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_city",
    sortParam: "company_city"
  }, {
    Header: "STATE",
    accessor: (row) => `${row.company_state ? row.company_state : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: statesData,
    queryParam: "company_state",
    sortParam: "company_state"
  }, {
    Header: "ZIP",
    accessor: (row) => `${row.company_zip ? row.company_zip : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "company_zip",
    sortParam: "company_zip"
  },
  // {
  //   Header: "NOTES",
  //   accessor: (row) => `${row.notes ? row.notes : "-"}`,
  //   isInputFilter: true,
  //   filterType:"text",
  //   query : "",
  //   dropDownOptions: [],
  //   queryParam : "notes",
  //   sortParam: "notes"
  // },
];

export const customHeadersForExport = [
  {
    agents: [
      { label: "FIRST NAME", key: "first_name" },
      { label: "LAST NAME", key: "last_name" },
      { label: "EMAIL", key: "email" },
      { label: "WORK PHONE", key: "phone" },
      { label: "CELL PHONE", key: "cell_phone" },
      { label: "ADDRESS", key: "address" },
      {label :"COMPANY ADDRESS" , key:"company_address"},
      { label: "COMPANY", key: "firm" },
      { label: "CITY", key: "city" },
      { label: "STATE", key: "state" },
      { label: "ZIP", key: "zip" },
    ],
    // "sellers": [
    //   { label: "STATUS", key: "status" },
    //   { label: "FIRST NAME", key: "first_name" },
    //   { label: "LAST NAME", key: "last_name" },
    //   { label: "EMAIL", key: "email" },
    //   { label: "PHONE", key: "phone" },
    //   { label: "COMPANY NAME", key: "company_name" },
    //   { label: "PROFILE", key: "profile" },
    //   { label: "COMPANY ADDRESS", key: "company_address" },
    //   { label: "CITY", key: "company_city" },
    //   { label: "STATE", key: "company_state" },
    //   { label: "ZIP", key: "company_zip" },
    // ],
    // "buyers":[
    //   { label: "STATUS", key: "status" },
    //   { label:"CATEGORY", key: "category" },
    //   { label: "TYPE", key: "type" },
    //   { label: "SUBCATEGORY",key:"single_tenant_subcategory",key1:"multi_tenant_subcategory"},
    //   { label: "MARKET", key: "market" },
    //   { label: "PRICE MIN", key: "price_min" },
    //   { label: "PRICE MAX", key: "price_max" },
    //   { label: "CAP RATE MIN", key: "cap_rate_min" },
    //   { label: "CAP RATE MAX", key: "cap_rate_max" },
    //   { label: "FIRST NAME", key: "first_name" },
    //   { label: "LAST NAME", key: "last_name" },
    //   { label: "EMAIL", key: "email" },
    //   { label: "PHONE", key: "phone" },
    //   { label: "COMPANY NAME", key: "company_name" },
    //   { label: "AGENT", key: "strive_agent_last_name" },
    //   { label: "COMPANY ADDRESS", key: "company_address" },
    //   { label: "CITY", key: "company_city" },
    //   { label: "STATE", key: "company_state" },
    //   { label: "ZIP", key: "company_zip" },
    //   { label:"PROFILE", key: "profile" },
    // ],
    investors: [
      { label: "FIRST NAME", key: "first_name" },
      { label: "LAST NAME", key: "last_name" },
      { label: "EMAIL", key: "email" },
      { label: "WORK PHONE", key: "phone" },
      { label: "CELL PHONE", key: "cell_phone" },
      { label: "COMPANY", key: "company_name" },
      { label: "ADDRESS", key: "company_address" },
      { label: "CITY", key: "company_city" },
      { label: "STATE", key: "company_state" },
      { label: "ZIP", key: "company_zip" },
      { label: "STATUS", key: "status" },
      { label: "CATEGORY", key: "category" },
      { label: "TYPE", key: "type" },
      {
        label: "SUBCATEGORY",
        key: "single_tenant_subcategory",
        key1: "multi_tenant_subcategory",
      },
      { label: "MARKET", key: "market" },
      { label: "PRICE MIN", key: "price_min" },
      { label: "PRICE MAX", key: "price_max" },
      { label: "CAP RATE MIN", key: "cap_rate_min" },
      { label: "CAP RATE MAX", key: "cap_rate_max" },
      { label: "PROFILE", key: "profile" },
      { label: "AGENT", key: "strive_agent_last_name" },
    ],
    "team-members": [
      { label: "ROLE", key: "is_agent" },
      { label: "NAME", name1: "first_name", name2: "last_name" },
      { label: "WORK PHONE", key: "phone" },
      { label: "CELL PHONE", key: "cell_phone" },
      { label: "START DATE", key: "starting_date" },
      { label: "YRS AT STRIVE", key: "yrs_at_strive" },
      { label: "BIRTH DATE", key: "birth_date" },
      { label: "ON PHONES", key: "on_phones" },
      // { label: "IN POOLS", key: "in_pool" },
      { label: "1ST LISTING", key: "first_listing" },
      { label: "1ST CLOSING", key: "first_closing" },
      { label: "ADDRESS", key: "address" },
      { label: "CITY", key: "city" },
      { label: "STATE", key: "state" },
      { label: "ZIP", key: "zip" },
    ],
    tenants: [
      { label: "FIRST NAME", key: "first_name" },
      { label: "LAST NAME", key: "last_name" },
      { label: "ADDRESS", key: "address" },
      { label: "CITY", key: "city" },
      { label: "STATE", key: "state" },
      { label: "ZIP", key: "zip" },
    ],
    lenders: [
      {label: "FIRST NAME", key: "contact_name"},
      {label: "LAST NAME", key: "contact_name"},
      {label: "EMAIL", key: "email"},
      {label: "WORK PHONE", key: "contact_phone"},
      {label: "CELL PHONE", key: "cell_phone"},
      { label: "COMPANY", key: "name" },
      { label: "ADDRESS", key: "address" },
      { label: "CITY", key: "city" },
      { label: "STATE", key: "state" },
      { label: "ZIP", key: "zip" },
    ],
    firms: [
      { label: "COMPANY", key: "name" },
      { label: "ADDRESS", key: "address" },
      { label: "CITY", key: "city" },
      { label: "STATE", key: "state" },
      { label: "ZIP", key: "zip" },
      { label: "PHONE", key: "phone" },
      { label: "WEBSITE", key: "website" },
      // { label: "EMAIL", key: "email" },
      { label: "PARENT COMPANY", key: "firm" },
    ],
    vendors: [
      { label: "VENDOR TYPE", key: "vendor_type" },
      { label: "FIRST NAME", key: "first_name" },
      { label: "LAST NAME", key: "last_name" },
      { label: "EMAIL", key: "email" },
      { label: "WORK PHONE", key: "phone" },
      {label: "CELL PHONE", key: "cell_phone"},
      { label: "COMPANY NAME", key: "company_name" },
      { label: "ADDRESS", key: "company_address" },
      { label: "CITY", key: "company_city" },
      { label: "STATE", key: "company_state" },
      { label: "ZIP", key: "company_zip" },
    ],
    
  },
];

export const teamMembersExportColumnConfig = [
  {
   Roster: [
    {
       label: "ROLE", key: "is_agent"
    },
    {
       label: "NAME", name1: "first_name", name2: "last_name" 
    },
    { label: "ADDRESS", key: "address" },
    { label: "CITY", key: "city" },
      { label: "STATE", key: "state" },
      { label: "ZIP", key: "zip" },
      { label: "YRS AT STRIVE", key: "yrs_at_strive" },
   { label: "START DATE", key: "starting_date" },
  ],
 "Call List" : [
   { label: "ROLE", key: "is_agent" },
   { label: "NAME", name1: "first_name", name2: "last_name" },
   { label: "WORK PHONE", key: "phone" },
   { label: "CELL PHONE", key: "cell_phone" },
   { label: "BIRTH DATE", key: "birth_date" },
  ], 
 "1st Listing & 1st Closing" : [
    { label: "NAME", name1: "first_name", name2: "last_name" },
    { label: "ON PHONES", key: "on_phones" },
  //  { label: "IN POOLS", key: "in_pool" },
   { label: "1ST LISTING", key: "first_listing" },
    { label: "1ST CLOSING", key: "first_closing" },
  ], 
Terminated:[
  { label: "Status", key: "termination_date" },
    { label: "ROLE", key: "is_agent" },
    { label: "NAME", name1: "first_name", name2: "last_name" },
    {
        label: 'DATE',
        key:"termination_date" ,
        key1:"arcimedes_modified"
    },
   { label: "YRS AT STRIVE", key: "starting_date" , key1:"termination_date" , key3:"arcimedes_modified"},
  ]
}
]

export  const mergingContactsColumns = { //dont change any column name payload and other functionality may effect
   Investors:[
    // {
    //   Header: 'Action',
    //   accessor:'action',
    // },
    {
      Header: 'SELECT FOR MERGE',
      accessor:'isMerge'
    }, 
    {
      Header: 'CONTACT ID',
      accessor:'contact_id'
    },
      {
      Header: 'FIRST NAME',
      accessor: "first_name"
    },  
    {
      Header: 'LAST NAME',
      accessor: 'last_name',
      Cell: ({ row }) => {
        const el = row.original;
        const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
        const currentSearch = window.location.search;
        const currentPath = window.location.pathname + currentSearch;

        return el.last_name ? (
          <Link
            to={{
              pathname: `${basePath}/Investor/${el.contact_id}`,
              search: '?tab=1',
              state: { fromListUrl: currentPath },
            }}
            style={{ color: "#90C54B", textDecoration: "underline", cursor: "pointer" }}
          >
            {el.last_name}
          </Link>
        ) : " ";
      }
    },
    {
      Header: 'EMAIL',
      accessor: (row) => (row.email ? <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> : null)
    },  {
      Header: 'PHONE',
      accessor:(row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.phone}</a> : null)
    },
    {
      Header: 'CELL PHONE',
      accessor:(row) => (row.cell_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.cell_phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.cell_phone}</a> : null)
    },

     {
      Header: 'COMPANY NAME',
      accessor: (row) => (row.company_name ? row.company_name : " ")
    },
     {
      Header: 'COMPANY ADDRESS',
      accessor: (row) => (row.company_address ? row.company_address : " ")
    }, {
      Header: 'CITY',
      accessor: (row) => (row.company_city ? row.company_city : " ")
    }, {
      Header: 'STATE',
      accessor: (row) => (row.company_state ? row.company_state : " ")
    },
    {
      Header: 'ZIP',
      accessor: (row) => (row.company_zip ? row.company_zip : " ")
    },
    // {
    //   Header: 'STATUS',
    //  accessor: (row) => `${row.status ? row.status :" " }`
    // }, 
    // {
    //   Header: 'CATEGORY',
    //   accessor: (row) => (row.category ? row.category : " ")
    // },
    // {
    //   Header: 'INVESTOR TYPE',
    //   accessor: (row) => (row.type ? row.type : " ")
    // }, {
    //   Header: 'SUBCATEGORY',
    //   accessor: row => row.type === 'MT' ? row.multi_tenant_subcategory : row.single_tenant_subcategory
    // },
    // {
    //   Header: 'MARKET',
    //   accessor: (row) => (row.market ? row.market : " ")
    // },
    // {
    //   Header: 'PRICE MIN',
    //   accessor: (row) => (row.price_min ? dollars(row.price_min) : " ")
    // },  {
    //   Header: 'PRICE MAX',
    //   accessor: (row) => (row.price_max ? dollars(row.price_max) : " ")
    // }, {
    //   Header: 'CAP RATE MIN',
    //   accessor: (row) => (row.cap_rate_min ? `${row.cap_rate_min}%` : "")
    // }, {
    //   Header: 'CAP RATE MAX',
    //   accessor: (row) => (row.cap_rate_max ? `${row.cap_rate_max}%` : " ")
    // }, 
 
    // {
    //   Header: 'AGENT',
    //   accessor: (row) => (row.strive_agent_last_name ? row.strive_agent_last_name : " ")
    // },
   
    {
      Header: 'PROFILE',
      accessor: (row) => (row.profile ? row.profile : " ")
    },
  ],
  Agent: [
  //   {
  //   Header: 'Action',
  //   accessor:'action',
  // },
    {
      Header: 'SELECT FOR MERGE',
      accessor: 'isMerge'
    },
    {
      Header: 'CONTACT ID',
      accessor: 'contact_id'
    },
    {
      Header: 'FIRST NAME',
      accessor: 'first_name'
    },
    {
      Header: 'LAST NAME',
      accessor: 'last_name',
      Cell: ({ row }) => {
        const el = row.original;
        const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
        const currentSearch = window.location.search;
        const currentPath = window.location.pathname + currentSearch;

        return el.last_name ? (
          <Link
            to={{
              pathname: `${basePath}/Agent/${el.contact_id}`,
              search: '?tab=1',
              state: { fromListUrl: currentPath },
            }}
            style={{ color: "#90C54B", textDecoration: "underline", cursor: "pointer" }}
          >
            {el.last_name}
          </Link>
        ) : " ";
      }
    },
    {
      Header: 'EMAIL',
      accessor: (row) => (row.email ? <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> : null)
    },
    {
      Header: 'WORK PHONE',
      accessor:(row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('/[()]/g', '')}`}>{row.phone}</a> : null)
  },
  {
    Header: 'CELL PHONE',
    accessor:(row) => (row.cell_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.cell_phone.replace(' ', '-').replace('/[()]/g', '')}`}>{row.cell_phone}</a> : null)
  },
   {
    Header: 'ADDRESS',
    accessor:'address',
  }, {
    Header: 'CITY',
    accessor:'city',
  }, {
    Header: 'STATE',
    accessor:'state',
  }, {
    Header: 'ZIP',
    accessor:'zip',
  },
  {
    Header: 'COMPANY',
    accessor:'firm',
  },
 
  
  ],
  // Seller: [
  //   {
  //     Header: 'SELECT FOR MERGE',
  //     accessor:'isMerge'
  //   },
  //   {
  //     Header: 'CONTACT ID',
  //     accessor:'contact_id'
  //   },
  //   {
  //     Header: 'STATUS',
  //     accessor: (row) => `${row.status ? row.status :" " }`
  //   },
  //   {
  //     Header: 'FIRST NAME',
  //     accessor: 'first_name'
  //   },
  //   {
  //     Header: 'LAST NAME',
  //     accessor: 'last_name'
  //   },
  //   {
  //     Header: 'EMAIL',
  //     accessor: (row) => (
  //         row.email ? 
  //         <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> : 
  //         null
  //     )
  //   },
  //   {
  //     Header: 'PHONE',
  //     accessor: (row) => (
  //         row.phone ? 
  //         <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>
  //             {row.phone}
  //         </a> : 
  //         null
  //     )
  //   },
  //   {
  //     Header: 'COMPANY NAME',
  //     accessor:(row) => `${row.company_name ? row.company_name :" " }`
  //   },
  //   {
  //     Header: "PROFILE",
  //     accessor: (row) => `${row.profile ? row.profile : " "}`
  //   },
  //   {
  //     Header: "COMPANY ADDRESS",
  //     accessor: (row) => `${row.company_address ? row.company_address : " "}`
  //   },
  //   {
  //     Header: "CITY",
  //     accessor: (row) => `${row.company_city ? row.company_city : " "}`
  //   },
  //   {
  //     Header: "STATE",
  //     accessor: (row) => `${row.company_state ? row.company_state : " "}`
  //   },
  //   {
  //     Header: "ZIP",
  //     accessor: (row) => `${row.company_zip ? row.company_zip : " "}`
  //   },
  //   {
  //     Header: 'Action',
  //     accessor:'action',
  //   },
  // ],
  // Buyer: [
  //   {
  //     Header: 'SELECT FOR MERGE',
  //     accessor:'isMerge'
  //   },
  //   {
  //     Header: 'CONTACT ID',
  //     accessor:'contact_id'
  //   },
  //   {
  //     Header: 'STATUS',
  //     accessor: (row) => (row.status ? row.status : " ")
  //   }, 
  //   {
  //     Header: 'CATEGORY',
  //     accessor: (row) => (row.category ? row.category : " ")
  //   }, 
  //   {
  //     Header: 'TYPE',
  //     accessor: (row) => (row.type ? row.type : " ")
  //   }, 
  //   {
  //     Header: 'SUBCATEGORY',
  //     accessor: row => row.type === 'MT' ? row.multi_tenant_subcategory : row.single_tenant_subcategory
  //   },
  //   {
  //     Header: 'MARKET',
  //     accessor: (row) => (row.market ? row.market : " ")
  //   }, 
  //   {
  //     Header: 'PRICE MIN',
  //     accessor: (row) => (row.price_min ? dollars(row.price_min) : " ")
  //   }, 
  //   {
  //     Header: 'PRICE MAX',
  //     accessor: (row) => (row.price_max ? dollars(row.price_max) : " ")
  //   },
  //   {
  //     Header: 'CAP RATE MIN',
  //     accessor: (row) => (row.cap_rate_min ? `${row.cap_rate_min}%` : "")
  //   },
  //   {
  //     Header: 'CAP RATE MAX',
  //     accessor: (row) => (row.cap_rate_max ? `${row.cap_rate_max}%` : " ")
  //   },
  //   {
  //     Header: 'FIRST NAME',
  //     accessor: (row) => (row.first_name ? row.first_name : " ")
  //   },
  //   {
  //     Header: 'LAST NAME',
  //     accessor: (row) => (row.last_name ? row.last_name : " ")
  //   },
  //   {
  //     Header: 'EMAIL',
  //     accessor: (row) => (row.email ? <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> : null)
  //   }, 
  //   {
  //     Header: 'PHONE',
  //     accessor:(row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.phone}</a> : null)
  //   }, 
  //   {
  //     Header: 'COMPANY NAME',
  //     accessor: (row) => (row.company_name ? row.company_name : " ")
  //   }, 
  //   {
  //     Header: 'AGENT',
  //     accessor: (row) => (row.strive_agent_last_name ? row.strive_agent_last_name : " ")
  //   }, 
  //   {
  //     Header: 'Action',
  //     accessor:'action',
  //   },
  // ],
  "Team-Members": [
    //  {
    //   Header: 'Action',
    //   accessor:'action',
    // },
    {
      Header: 'SELECT FOR MERGE',
      accessor: 'isMerge'
    },
    {
      Header: 'CONTACT ID',
      accessor:'contact_id'
    },
    {
      Header: 'FIRST NAME',
      accessor: 'first_name'
    },
    {
      Header: 'LAST NAME',
      accessor: 'last_name'
    },
    {
      Header: 'ROLE',
      accessor: (row) => `${row.is_agent === "y" ? "Agent" : row.is_agent === "h" ? "AthCap - Agent" :  row.is_agent === "e" ? "AthCap - Employee": row.is_agent === "i" ? "Intern" : "Employee"}`
    },   
    //  {
    //   Header: 'NAME',
    //   accessor:  (row) => row.first_name && row.last_name ? `${row.first_name} ${row.last_name}` : ''
    // },
    {
      Header: 'WORK PHONE',
      accessor: (row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.phone}</a> : null),
    },
    {
      Header: 'CELL PHONE',
      accessor: (row) => (row.cell_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.cell_phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.cell_phone}</a> : null),
    },
     {
      Header: 'ADDRESS',
      accessor: (row) => `${row.address ? row.address : " "}`
    },
    {
      Header: 'STATE',
      accessor: (row) => `${row.state ? row.state : " "}`
    },
    {
      Header: 'CITY',
      accessor: (row) => `${row.city ? row.city : " "}`
    },
    {
      Header: 'ZIP',
      accessor: (row) => `${row.zip ? row.zip : " "}`
    },
    {
      Header: 'START DATE',
      accessor: (row) => `${row.starting_date ? row.starting_date : " "}`
    },
    {
      Header: 'YRS AT STRIVE',
      accessor: (row) => `${row.starting_date ? calculateYearsAndMonths(new Date(row.starting_date)) : ''}`
    },
    {
      Header: 'BIRTH DATE',
      accessor: (row) => `${row.birth_date ? row.birth_date : " "}`
    },
    {
      Header: 'ON PHONES',
      accessor: (row) => `${row.on_phones ? row.on_phones : " "}`
    },
    /*{
      Header: 'IN POOLS',
      accessor: (row) => `${row.in_pool ? row.in_pool : ''}`
    },*/
    {
      Header: '1ST LISTING',
      accessor: (row) => `${row.first_listing ? row.first_listing : " "}`
    },
    {
      Header: '1ST CLOSING',
      accessor: (row) => `${row.first_closing ? row.first_closing : " "}`
    },
   
   
  ],
   Lender: [ 
  // {
  //   Header: 'Action',
  //   accessor:'action',
  // }, 
    {
      Header: 'SELECT FOR MERGE',
      accessor: 'isMerge'
    },
    {
      Header: 'CONTACT ID',
      accessor: 'contact_id'
    },
      {
      Header: 'FIRST NAME',
      accessor: 'first_name'
    },
    {
      Header: 'LAST NAME',
      accessor: 'last_name',
      Cell: ({ row }) => {
        const el = row.original;
        const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
        const currentSearch = window.location.search;
        const currentPath = window.location.pathname + currentSearch;

        return el.last_name ? (
          <Link
            to={{
              pathname: `${basePath}/Lender/${el.contact_id}`,
              search: '?tab=3',
              state: { fromListUrl: currentPath },
            }}
            style={{ color: "#90C54B", textDecoration: "underline", cursor: "pointer" }}
          >
            {el.last_name}
          </Link>
        ) : " ";
      }
    },
     { Header: 'EMAIL',
    accessor:(row) => (row.email ? <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> : null)
  },
   {
      Header: 'PHONE #',
      accessor: (row) => (row.contact_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.contact_phone.replace(' ', '-').replace('/[()]/g', '')}`}>{row.contact_phone}</a> : null)
    },
     { Header: 'ADDRESS',
    accessor:(row) => (row.address ? row.address: null)
  }, {
      Header: 'CITY',
      accessor: 'city'
    },
    {
      Header: 'STATE',
      accessor: 'state'
    },
  { Header: 'ZIP',
    accessor:(row) => (row.zip ? row.zip : null)
  },
    {
      Header: 'Company',
      accessor:'name'
    },
   
 
  ],
  Tenant: [
    // {
    //   Header: 'Action',
    //   accessor:'action',
    // },
    {
      Header: 'SELECT FOR MERGE',
      accessor:'isMerge'
    },
    {
      Header: 'CONTACT ID',
      accessor:'contact_id'
    },
    {
      Header: 'FIRST NAME',
      accessor:'first_name'
    },
    {
      Header: 'LAST NAME',
      accessor:'last_name'
    },  {
      Header: 'ADDRESS',
      accessor: (row) => (row.address ? row.address : " ")
    },  {
      Header: 'CITY',
      accessor: (row) => (row.city ? row.city : " ")
    },  {
      Header: 'STATE',
      accessor: (row) => (row.state ? row.state : " ")
    },  {
      Header: 'ZIP',
      accessor: (row) => (row.zip ? row.zip : " ")
    },
  
  ],
  Vendor:[
    // {
    //   Header: 'Action',
    //   accessor: 'action',
    // },
    {
      Header: 'SELECT FOR MERGE',
      accessor: 'isMerge'
    },
    {
      Header: 'CONTACT ID',
      accessor:'contact_id'
    },
     {
      Header: 'FIRST NAME',
      accessor: "first_name"
    }, {
      Header: 'LAST NAME',
      accessor: 'last_name',
      Cell: ({ row }) => {
        const el = row.original;
        const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
        const currentSearch = window.location.search;
        const currentPath = window.location.pathname + currentSearch;

        return el.last_name ? (
          <Link
            to={{
              pathname: `${basePath}/Vendor/${el.contact_id}`,
              search: '?tab=1',
              state: { fromListUrl: currentPath },
            }}
            style={{ color: "#90C54B", textDecoration: "underline", cursor: "pointer" }}
          >
            {el.last_name}
          </Link>
        ) : " ";
      }
    }, 
    {
      Header: 'EMAIL',
      accessor: (row) => (row.email ? <a style={{ color: "#90C54B" }} href={`mailto:${row.email}`}>{row.email}</a> : null)
    }, {
      Header: 'PHONE',
      accessor: (row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.phone}</a> : null)
    }, 
    {
      Header: 'COMPANY ADDRESS',
      accessor: (row) => (row.company_address ? row.company_address : " ")
    }, {
      Header: 'CITY',
      accessor: (row) => (row.company_city ? row.company_city : " ")
    }, {
      Header: 'STATE',
      accessor: (row) => (row.company_state ? row.company_state : " ")
    },
    {
      Header: 'ZIP',
      accessor: (row) => (row.company_zip ? row.company_zip : " ")
    },
    {
      Header: 'VENDOR TYPE',
     accessor: (row) => `${row.vendor_type ? row.vendor_type :" " }`
    }, 
   
    {
      Header: 'COMPANY NAME',
      accessor: (row) => (row.company_name ? row.company_name : " ")
    },
    
  ]

};



export const mergingCompanyColumns= {
  Firm:[
    // {
    //   Header: 'Action',
    //   accessor:'action',
    // },
    {
      Header: 'SELECT FOR MERGE',
      accessor: 'isMerge'
    },
    {
      Header: 'COMPANY ID',
      accessor: 'company_id'
    },
    {
      Header: 'COMPANY',
      accessor: 'name',
    },
    {
      Header: 'ADDRESS',
      accessor: 'address'
    },
    {
      Header: 'CITY',
      accessor: 'city'
    },
    {
      Header: 'STATE',
      accessor: 'state'
    },
    {
      Header: 'ZIP',
      accessor: (row) => (row.zip ? row.zip : " ")
    },
    {
      Header: 'PHONE',
      accessor: (row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('/[()]/g', '')}`}>{row.phone}</a> : null)
    },
    {
      Header: 'WEBSITE',
      accessor: 'website'
    },
    // {
    //   Header: 'Email',
    //   accessor: 'email'
    // },
    {
      Header: 'PARENT COMPANY',
      accessor: 'firm'
    },
   
  ]
}


export const TEAM_MEMBERS_ROSTER_COLUMNS = [
  {
    Header: 'ROLE',
    accessor: (row) => `${row.is_agent === "y" ? "Agent" : row.is_agent === "h" ? "AthCap - Agent" : row.is_agent === "e" ? "AthCap - Employee": row.is_agent === "i" ? "Intern" : "Employee"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [{
      code: 'n',
      label: 'Employee',
    },
    {
      code: 'y',
      label: 'Agent',
    },
    {
      code: 'h',
      label: 'AthCap - Agent',
    },
    {
      code: 'e',
      label: 'AthCap - Employee',
    },
    {
      code: 'i',
      label: 'Intern',
    }],
    queryParam: "is_agent",
    sortParam: "is_agent"
  },
  {
    Header: 'NAME',
    accessor: (row) => row.first_name && row.last_name ? `${row.first_name} ${row.last_name}` : '',
    isInputFilter: true,
    filterType: "Dropdown",
    query: GET_CONTACT_TEAM_LIST_QUERY,
    dropDownOptions: [],
    queryParam: "arcimedes_row_id",
    sortParam: "first_name",
    queryType: "Team"
  },{
    Header: 'ADDRESS',
    accessor: (row) => `${row.address ? row.address : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "address",
    sortParam: "address"
  } ,{
    Header: 'CITY',
    accessor: (row) => `${row.city ? row.city : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "city",
    sortParam: "city"
  },
  {
    Header: "STATE",
    accessor: (row) => `${row.state ? row.state : "-"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: statesData,
    queryParam: "state",
    sortParam: "state"
  }, {
    Header: 'ZIP',
    accessor: (row) => `${row.zip ? row.zip : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "zip",
    sortParam: "zip"
  },
  {
    Header: 'YRS AT STRIVE',
    accessor: (row) => `${row.yrs_at_strive ? row.yrs_at_strive : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "yrs_at_strive",
    sortParam: "yrs_at_strive"
  },
  {
    Header: 'START DATE',
    accessor: (row) => `${row.starting_date ? row.starting_date : " "}`,
    isInputFilter: true,
    filterType: "datepicker",
    query: "",
    dropDownOptions: [],
    sortParam: "starting_date",
    queryParam: "starting_date_min",
    queryParam1: "starting_date_max"
  }
];

export const TEAM_MEMBERS_CALL_LIST_COLUMNS = [
  {
    Header: 'ROLE',
    accessor: (row) => `${row.is_agent === "y" ? "Agent" : row.is_agent === "h" ? "AthCap - Agent" : row.is_agent === "e" ? "AthCap - Employee": row.is_agent === "i" ? "Intern" : "Employee"}`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [{
      code: 'n',
      label: 'Employee',
    },
    {
      code: 'y',
      label: 'Agent',
    },
    {
      code: 'h',
      label: 'AthCap - Agent',
    },
    {
      code: 'e',
      label: 'AthCap - Employee',
    },
    {
      code: 'i',
      label: 'Intern',
    }],
    queryParam: "is_agent",
    sortParam: "is_agent",
    alignStyle: "center"
  },
  {
    Header: 'NAME',
    accessor: (row) => row.first_name && row.last_name ? `${row.first_name} ${row.last_name}` : '',
    isInputFilter: true,
    filterType: "Dropdown",
    query: GET_CONTACT_TEAM_LIST_QUERY,
    dropDownOptions: [],
    queryParam: "arcimedes_row_id",
    sortParam: "first_name",
    queryType: "Team",
    alignStyle: "center"
  }, {
    Header: 'WORK PHONE',
    accessor: (row) => (row.phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "phone",
    sortParam: "phone",
    alignStyle: "center"
  }, {
    Header: 'CELL PHONE',
    accessor: (row) => (row.cell_phone ? <a style={{ color: "#90C54B" }} href={`tel:${row.cell_phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{row.cell_phone}</a> : null),
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    sortParam: "cell_phone",
    queryParam: "cell_phone",
    alignStyle: "center"

  },
  {
    Header: 'BIRTH DATE',
    accessor: (row) => `${row.birth_date ? row.birth_date : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "birth_date",
    sortParam: "birth_date",
    alignStyle: "center"
  }
];

export const TEAM_MEMBERS_1ST_LISTING_1ST_CLOSING_COLUMNS = [
  {
    Header: 'NAME',
    accessor: (row) => row.first_name && row.last_name ? `${row.first_name} ${row.last_name}` : '',
    isInputFilter: true,
    filterType: "Dropdown",
    query: GET_CONTACT_TEAM_LIST_QUERY,
    dropDownOptions: [],
    queryParam: "arcimedes_row_id",
    sortParam: "first_name",
    queryType: "Team",
    alignStyle: "center"
  },
  {
    Header: 'ON PHONES',
    accessor: (row) => `${row.on_phones ? row.on_phones : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "on_phones",
    sortParam: "on_phones",
    alignStyle: "center"
  },
  /*{
    Header: 'IN POOLS',
    accessor: (row) => `${row.in_pool ? row.in_pool : ''}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "in_pool",
    sortParam: "in_pool",
    alignStyle: "center"
  },*/
  {
    Header: '1ST LISTING',
    accessor: (row) => `${row.first_listing ? row.first_listing : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "first_listing",
    sortParam: "first_listing",
    alignStyle: "center"
  }, {
    Header: '1ST CLOSING',
    accessor: (row) => `${row.first_closing ? row.first_closing : "-"}`,
    isInputFilter: true,
    filterType: "text",
    query: "",
    dropDownOptions: [],
    queryParam: "first_closing",
    sortParam: "first_closing",
    alignStyle: "center"
  }
];

export const TEAM_MEMBERS_TERMINATED_COLUMNS = [
  {
    Header: "Status",
    accessor: (row) => `${row.termination_date ? "Terminated" : "Deleted"}`,
    sortParam: "termination_status",
    queryParam: "termination_status",
    alignStyle: "center",
  },
  {
    Header: "ROLE",
    accessor: (row) =>
      `${
        row.is_agent === "y"
          ? "Agent"
          : row.is_agent === "h"
          ? "AthCap - Agent"
          : row.is_agent === "e"
          ? "AthCap - Employee"
          : "Employee"
      }`,
    isInputFilter: true,
    filterType: "Static Dropdown",
    query: "",
    dropDownOptions: [
      {
        code: "n",
        label: "Employee",
      },
      {
        code: "y",
        label: "Agent",
      },
      {
        code: "h",
        label: "AthCap - Agent",
      },
      {
        code: "e",
        label: "AthCap - Employee",
      },
    ],
    queryParam: "is_agent",
    sortParam: "is_agent",
    alignStyle: "center",
  },
  {
    Header: "NAME",
    accessor: (row) => (
      <Link
        // to={{ pathname: `${arc.path.base}teamMember/${row.original.contact_id}`}}
        style={{
          color: "#90c54b",
        }}
        to={{
          pathname: `${arc.path.base}teamMember/${row.contact_id}`,
          state: {
            fromListUrl: window.location.pathname + window.location.search,
          },
        }}
      >
        {row.first_name && row.last_name
          ? `${row.first_name} ${row.last_name}`
          : ""}
      </Link>
    ),

    isInputFilter: true,
    filterType: "Dropdown",
    query: GET_CONTACT_TEAM_LIST_QUERY,
    dropDownOptions: [],
    queryParam: "arcimedes_row_id",
    sortParam: "first_name",
    queryType: "Team",
    alignStyle: "center",
    filters: { filters: { terminated: true } },
  },
  {
    Header: "DATE",
    accessor: (row) =>
      `${
        row.termination_date
          ? row.termination_date
          : row.arcimedes_modified
          ? format_arcimedes_modified_Date(row.arcimedes_modified)
          : " "
      }`,
    isInputFilter: false,
    filterType: "",
    query: "",
    dropDownOptions: [],
    sortParam: "termination_date",
    queryParam: "termination_date",
    alignStyle: "center",
  },
  {
    Header: "YRS AT STRIVE",
    accessor: (row) => {
      if (row.starting_date && row.termination_date) {
        return getCompletedYearsAndMonths(
          row.starting_date,
          row.termination_date
        );
      }

      if (row.starting_date && row.arcimedes_modified) {
        const formattedArcimedesDate = format_arcimedes_modified_Date(
          row.arcimedes_modified
        );
        return getCompletedYearsAndMonths(
          row.starting_date,
          formattedArcimedesDate
        );
      }

      return "";
    },
    isInputFilter: false,
    filterType: "",
    query: "",
    dropDownOptions: [],
    queryParam: "yrs_at_strive",
    sortParam: "yrs_at_strive",
    alignStyle: "center",
  },
];